import Input from '#components/general/Input';
import { getSubStepValues } from '#models/general/steps';

import { SPIRIT_REDUCTIONS_SUBSTEPS_IDS, SPIRIT_REDUCTION_WATER_READINGS_FIELDS } from './constants';

export const getWaterReadingsFields = ({ values, errors }) => {
  const getWaterReadingsValues = getSubStepValues(
    SPIRIT_REDUCTIONS_SUBSTEPS_IDS.WATER_READINGS,
    values,
    errors
  );
  return [
    {
      ...getWaterReadingsValues(SPIRIT_REDUCTION_WATER_READINGS_FIELDS.READING_BEFORE),
      Component: Input,
      noMargin: true
    },
    {
      ...getWaterReadingsValues(SPIRIT_REDUCTION_WATER_READINGS_FIELDS.READING_AFTER),
      Component: Input,
      noMargin: true
    },
    {
      ...getWaterReadingsValues(SPIRIT_REDUCTION_WATER_READINGS_FIELDS.WATER_USAGE),
      Component: Input,
      noMargin: true
    }
  ];
};
